export enum ActivatableTransportType {

  NOT_RELEVANT = 'NOT_RELEVANT', DELETED = 'DELETED'

}
